module.exports = __webpack_public_path__ + "static/media/sidebar-3.f8f22bd6.jpg";